// Un rendu Markdown minimal, pour lire un compte rendu sans ses astérisques.
//
// Pas de bibliothèque : le besoin tient en six formes — titres, gras, italique, listes,
// citations, code — et une dépendance de plus serait une surface d'attaque et une dette de
// mise à jour pour un gain nul. Ce qui n'est pas reconnu reste du texte, ce qui est
// exactement le comportement voulu : un compte rendu doit s'afficher même mal écrit.
//
// L'échappement passe **avant** toute reconnaissance de forme. Un transcript vient d'un
// fichier déposé par un tiers ; le traiter comme du balisage de confiance serait ouvrir
// une injection dans l'écran qui sert à juger les gens.
import { Brut, esc } from './ui.ts';

const enLigne = (t: string) => t
  .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')
  .replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<i>$2</i>')
  .replace(/`([^`\n]+)`/g, '<code>$1</code>');

export function rendreMarkdown(source: string): Brut {
  const lignes = esc(source).split('\n');
  const sortie: string[] = [];
  let liste = false;
  const fermerListe = () => { if (liste) { sortie.push('</ul>'); liste = false; } };

  for (const ligne of lignes) {
    const l = ligne.trimEnd();

    const titre = /^(#{1,4})\s+(.*)$/.exec(l);
    if (titre) {
      fermerListe();
      const n = Math.min(titre[1]!.length + 2, 6);
      sortie.push(`<h${n} class="md-t">${enLigne(titre[2]!)}</h${n}>`);
      continue;
    }

    const puce = /^\s*[-*+•]\s+(.*)$/.exec(l) ?? /^\s*\d+[.)]\s+(.*)$/.exec(l);
    if (puce) {
      if (!liste) { sortie.push('<ul class="md-l">'); liste = true; }
      sortie.push(`<li>${enLigne(puce[1]!)}</li>`);
      continue;
    }

    if (/^\s*&gt;\s?/.test(l)) {
      fermerListe();
      sortie.push(`<blockquote class="md-c">${enLigne(l.replace(/^\s*&gt;\s?/, ''))}</blockquote>`);
      continue;
    }

    if (/^\s*(?:---+|___+|\*\*\*+)\s*$/.test(l)) { fermerListe(); sortie.push('<hr class="md-r">'); continue; }

    if (!l.trim()) { fermerListe(); continue; }

    fermerListe();
    sortie.push(`<p class="md-p">${enLigne(l)}</p>`);
  }
  fermerListe();
  return new Brut(sortie.join(''));
}
